module.exports = __webpack_public_path__ + "img/UTDEAD-4.1bc94056.jpg";